module.exports = __webpack_public_path__ + "img/cash.3c6dd2ee.png";